var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper", attrs: { id: "app" } },
    [
      _c("header-bar", { attrs: { route: _vm.route, locale: _vm.locale } }),
      _c("transition", { attrs: { mode: "out-in" } }, [_c("router-view")], 1),
      _c("footer-bar")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/layouts/DesktopLayout.vue?vue&type=template&id=43e4eb37&
// module id = 320
// module chunks = 10